import CollageDesignerBackgroundControls from './CollageDesignerBackgroundControls';
import CollageDesignerBackgroundControlsButton from './CollageDesignerBackgroundControlsButton';

export { CollageDesignerBackgroundControlsButton };

export default CollageDesignerBackgroundControls;
